import { RequestStatus } from 'constants/RequestStatus';

import { PayloadAction } from '@reduxjs/toolkit';
import { PlanPredictCurvesWithIdRequestPayload } from 'api/curves';

import { createSlice } from 'utils/@reduxjs/toolkit';

import { ECurvesType, PlanProdCurvesLoadedType, PlanProdCurvesWellState, PlanProdCurvesWidgetState } from './types';
import { getEmissionRawData, getFilteredEmissionData } from './utils';

const defaultPlanProdCurvesWellState: PlanProdCurvesWellState = {
  status: RequestStatus.IDLE,
  error: null,
  dataKey: null,
  [ECurvesType.PROD_CURVES]: {
    data: null,
    rawData: null,
  },
  [ECurvesType.EMISSION_CURVES]: {
    data: null,
    rawData: null,
  },
};

export const initialState: PlanProdCurvesWidgetState = {};

export const {
  actions,
  reducer,
  name: sliceKey,
} = createSlice({
  name: 'planProdCurvesWidget',
  initialState,
  reducers: {
    loadPlansProdCurves(state, { payload }: PayloadAction<PlanPredictCurvesWithIdRequestPayload[]>) {
      payload.forEach(({ wellId, ...parameters }) => {
        if (state[wellId]) {
          state[wellId].status = RequestStatus.LOADING;
          state[wellId].error = defaultPlanProdCurvesWellState.error;
        } else {
          state[wellId] = { ...defaultPlanProdCurvesWellState, status: RequestStatus.LOADING };
        }
        state[wellId].dataKey = JSON.stringify(parameters);
      });
    },
    planProdCurvesLoaded(
      state,
      { payload: { wellsPayload, rawData, chartData, emmisionChartData } }: PayloadAction<PlanProdCurvesLoadedType>,
    ) {
      wellsPayload.forEach(({ wellId }) => {
        const wellData = getFilteredEmissionData(emmisionChartData, wellId);
        state[wellId].status = RequestStatus.SUCCESS;
        state[wellId][ECurvesType.PROD_CURVES].data = chartData[wellId];
        state[wellId][ECurvesType.EMISSION_CURVES].data = wellData;
        state[wellId][ECurvesType.EMISSION_CURVES].rawData = getEmissionRawData(wellData, wellId);
        state[wellId][ECurvesType.PROD_CURVES].rawData = rawData.filter((item) => item.wellId === wellId);
      });
    },
    plansProdCurvesError(
      state,
      {
        payload: { wellsPayload, error },
      }: PayloadAction<{ wellsPayload: PlanPredictCurvesWithIdRequestPayload[]; error: string }>,
    ) {
      wellsPayload.forEach(({ wellId }) => {
        state[wellId].status = RequestStatus.FAILURE;
        state[wellId].error = error;
      });
    },
    clearProdCurvesError(state) {
      Object.keys(state).forEach((wellId) => {
        state[Number(wellId)].status = RequestStatus.IDLE;
        state[Number(wellId)].error = null;
      });
    },
    removePlanProdCurves(state, { payload: wellId }: PayloadAction<number>) {
      delete state[wellId];
    },
    removeAllPlanProdCurves(_state) {
      return { ...initialState };
    },
  },
});
